<template>
  <div class="menu-wrapper">
    <template v-for="item in routes" v-if="!item.hidden&&item.children&&item.meta.agency_type !== $store.state.user.userinfo.agency_type && roleControlRoute(item.meta.role)"  >

      <router-link v-if="item.children.length===1 && !item.children[0].children && !item.alwaysShow" :to="item.path+'/'+item.children[0].path"
        :key="item.children[0].name">
        <el-menu-item :index="item.path+'/'+item.children[0].path" :class="{'submenu-title-noDropdown':!isNest}">
          <i v-if="item.children[0].meta&&item.children[0].meta.icon" :class="'icon iconfont icon-'+item.children[0].meta.icon"></i>
          <span v-if="item.children[0].meta&&item.children[0].meta.title" slot="title">{{item.children[0].meta.title}}</span>
        </el-menu-item>
      </router-link>

      <el-submenu v-else :index="item.name||item.path" :key="item.name"   >
        <template slot="title">
          <i v-if="item.meta&&item.meta.icon" :class="'icon iconfont icon-'+item.meta.icon"></i>
          <span v-if="item.meta&&item.meta.title" slot="title">{{item.meta.title}}</span>
        </template>

        <template v-for="child in item.children" v-if="child.meta.agency_type !== $store.state.user.userinfo.agency_type&&child.path!='' && roleControlRoute(child.meta.role)">
          <sidebar-item :is-nest="true" class="nest-menu" v-if="child.children&&child.children.length>0" :routes="[child]" :key="child.path"></sidebar-item>

          <router-link v-else :to="item.path+'/'+child.path" :key="child.name" >
            <el-menu-item :index="item.path+'/'+child.path"  @click="RefreshUserInfo(child.isRefreshUserInfo)">
              <i v-if="child.meta&&child.meta.icon" :class="'icon iconfont icon-'+child.meta.icon"></i>
              <span v-if="child.meta&&child.meta.title" slot="title">{{child.meta.title}}</span>
            </el-menu-item>
          </router-link>
        </template>
      </el-submenu>

    </template>
  </div>
</template>

<script>
export default {
  name: 'SidebarItem',
  props: {
    routes: {
      type: Array
    },
    isNest: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getMenberInfo() {
      this.$store.dispatch('GetInfo')
    },
    RefreshUserInfo(isRefreshUserInfo){
      if(isRefreshUserInfo){
       this.getMenberInfo();
      }
    },
    roleControlRoute(roles){
      // 角色不存在，说明非运营账号，则按代理策略显示
      if(!this.$store.getters.userinfo.role) return true;
      // 角色不存在则不显示
      if(!roles) return false;
      
      // 包含该角色的权限显示
      const role = this.$store.getters.userinfo.role;
      if(roles.includes(role)) return true

      return false
    }
  }
}
</script>

<style>
  .icon {
    font-size: 12px;
  }
</style>
